/* Noura Nest — product page behaviour: gallery, variant picker, qty, lightbox */
(function () {
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function init(root) {
    if (root.getAttribute('data-nn-ready')) return;
    root.setAttribute('data-nn-ready', '1');

    var variantsEl = root.querySelector('[data-nn-variants]');
    var variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) {}
    var idInput = root.querySelector('[data-nn-variant-id]');
    var priceEl = root.querySelector('[data-nn-price]');
    var atc = root.querySelector('[data-nn-atc]');
    var atcLabel = root.querySelector('[data-nn-atc-label]');
    var groups = root.querySelectorAll('[data-nn-option]');
    var slides = root.querySelectorAll('[data-nn-slide]');
    var thumbs = root.querySelectorAll('[data-nn-thumb]');

    function showSlide(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showSlide(parseInt(t.getAttribute('data-nn-thumb'), 10)); });
    });

    function setNeeds(on) { root.classList.toggle('nn-pdp--needs-option', on); }

    function update() {
      var chosen = [];
      groups.forEach(function (g) {
        var c = g.querySelector('input:checked');
        chosen.push(c ? c.value : null);
      });
      if (!groups.length) return;
      if (chosen.indexOf(null) !== -1) { setNeeds(true); return; }
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (!v) {
        atc.disabled = true; atcLabel.textContent = atc.getAttribute('data-sold'); setNeeds(true); return;
      }
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (priceEl) {
        priceEl.innerHTML = v.sale
          ? '<span class="is-sale">' + esc(v.price) + '</span><s>' + esc(v.compare) + '</s>'
          : '<span>' + esc(v.price) + '</span>';
      }
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? atc.getAttribute('data-add') : atc.getAttribute('data-sold');
      setNeeds(!v.available);
      if (v.media) {
        slides.forEach(function (s, n) { if (String(s.getAttribute('data-media-id')) === String(v.media)) showSlide(n); });
      }
      try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
    }
    groups.forEach(function (g) { g.addEventListener('change', update); });

    var qty = root.querySelector('[data-nn-qty]');
    var minus = root.querySelector('[data-nn-qty-minus]');
    var plus = root.querySelector('[data-nn-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    var dlg = root.querySelector('[data-nn-lightbox]');
    var enlarge = root.querySelector('[data-nn-enlarge]');
    if (dlg && enlarge) {
      enlarge.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); });
      var close = dlg.querySelector('[data-nn-lb-close]');
      if (close) close.addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    var wish = root.querySelector('[data-nn-wish]');
    if (wish) {
      wish.addEventListener('click', function () {
        var on = wish.getAttribute('aria-pressed') !== 'true';
        wish.setAttribute('aria-pressed', on ? 'true' : 'false');
        var p = wish.querySelector('path');
        if (p) p.setAttribute('fill', on ? 'currentColor' : 'none');
      });
    }
  }

  function boot() { document.querySelectorAll('[data-nn-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();